jQuery(document).ready(function($)
{   

    $('.btn-load-more-ajax a').on('click',function()
    {
        var btn = $(this);

        var contentTarget = btn.parent().data('target');

        var appendTo = btn.parent().data('append-to');

        var loadMore = btn.parent().data('load-more');

        $.get(btn.attr('href'), function(data)
        {


            $( appendTo ).append($(data).find( contentTarget ));


            var nextBtn = $(data).find( loadMore ).attr('href');

            if(nextBtn)
            {

                btn.attr('href',nextBtn);
            }
            else
            {
                btn.parent().hide();
            }

        });

        return false;
    });


    $('#load-more-cases a').on('click', function()
    {
        var btn = $(this);

        $.get(btn.attr('href'), function(data)
        {


            $('.notable-cases .cols .col:first-child').append($(data).find('.notable-cases .cols .col:first-child .case-box'));
            $('.notable-cases .cols .col:last-child').append($(data).find('.notable-cases .cols .col:last-child .case-box'));

            var nextBtn = $(data).find( '#load-more-cases a' ).attr('href');

            if(nextBtn)
            {

                btn.attr('href',nextBtn);
            }
            else
            {
                btn.parent().hide();
            }

        });

        return false;
    });

    $('#load-more-testimonials a').on('click', function()
    {
        var btn = $(this);

        $.get(btn.attr('href'), function(data)
        {


            $('.testimonials .columns .col:first-child').append($(data).find('.testimonials .columns .col:first-child .testimonial-box'));
            $('.testimonials .columns .col:last-child').append($(data).find('.testimonials .columns .col:last-child .testimonial-box'));

            var nextBtn = $(data).find( '#load-more-testimonials a' ).attr('href');

            if(nextBtn)
            {

                btn.attr('href',nextBtn);
            }
            else
            {
                btn.parent().hide();
            }

        });

        return false;
    });

    
});